import { render, staticRenderFns } from "./HeaderInformationNavigationWrktp.vue?vue&type=template&id=64fcc0b2&scoped=true"
import script from "./HeaderInformationNavigationWrktp.vue?vue&type=script&lang=ts"
export * from "./HeaderInformationNavigationWrktp.vue?vue&type=script&lang=ts"
import style0 from "./HeaderInformationNavigationWrktp.vue?vue&type=style&index=0&id=64fcc0b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fcc0b2",
  null
  
)

export default component.exports